import React from "react";
import { Link } from "react-router-dom";

export default function LegalFooter({ dark }) {
  const textColor = dark ? "#86efac" : "#9ca3af";
  const linkColor = dark ? "#bbf7d0" : "#6b7280";
  return (
    <p style={{ textAlign: "center", fontSize: "11px", color: textColor, margin: 0 }}>
      © 2026 Michael Sellman. Golf Society Manager. All rights reserved. · <Link to="/privacy-policy" style={{ color: linkColor, textDecoration: "underline" }}>Privacy Policy</Link> · <Link to="/data-processing-agreement" style={{ color: linkColor, textDecoration: "underline" }}>Data Processing Agreement</Link> · ICO Registration: ZC176881
    </p>
  );
}
